import type { EntitlementsMap, ProductId } from './types';
import { resolveCheckoutReturnTo } from './purchaseSteps';

export const CHECKOUT_SYNC_EVENT = 'smsp:checkout-synced';
export const ASSIGNMENTS_INVALIDATE_EVENT = 'smsp:assignments-invalidate';

export type CheckoutSyncedDetail = {
  productId: ProductId;
  assignmentId: number;
  entitlements?: EntitlementsMap;
  productName?: string;
  alreadyFulfilled?: boolean;
};

export function dispatchCheckoutSynced(detail: CheckoutSyncedDetail): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(CHECKOUT_SYNC_EVENT, { detail }));
  window.dispatchEvent(new CustomEvent(ASSIGNMENTS_INVALIDATE_EVENT));
}

/** Where the buyer should land after IAP or deferred native checkout sync. */
export function resolvePostCheckoutNavigation(
  detail: CheckoutSyncedDetail,
): string | null {
  if (!detail.assignmentId) {
    return null;
  }
  if ('entitlements' in detail && detail.entitlements) {
    const returnTo = resolveCheckoutReturnTo({
      entitlements: detail.entitlements,
      productId: detail.productId,
      assignmentId: detail.assignmentId,
    });
    if (returnTo) {
      return returnTo;
    }
  }
  return `/assignments/${detail.assignmentId}/onboarding`;
}
